// removed by extract-text-webpack-plugin
module.exports = {"hidden":"WE8MM","visuallyhidden":"_25uxr","hide-text":"_1KlJU","center":"_1MNTZ","noprint":"_3_Rqs","leadText":"dUYxZ _-_Vfy"};


/*****************
 ** WEBPACK FOOTER
 ** ./themes/ui-lead-text/styles/feature.scss
 ** module id = 135
 ** module chunks = 2
 **/